import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Spin, Icon } from 'antd';

export class Logout extends Component {
  static propTypes = {
    acessoSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.logout();
  }

  logout = () => {
    this.props.actions.logout(action => {
      if (action === 'ACESSO_SISTEMA_LOGOUT_SUCCESS') {
        localStorage.clear();
        this.props.history.push('/login');
      }
    });
  };
  render() {
    const { acessoSistema } = this.props;
    return (
      <div className="acesso-sistema-logout">
        <Spin
          spinning={acessoSistema.logoutPending}
          indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
          size="large"
          tip="Saindo..."
          className="load"
          style={{ minHeight: '100vh' }}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    acessoSistema: state.acessoSistema,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Logout);



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/Logout.js